import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { settingsState } from "./settings.types";
import { getDevices, getMySettings, updateMySettings } from "./settings.thunk";
import { connectWebPush } from "./push.thunk";

const initialState: settingsState = {
  appLevel: 2,
  isError: false,
  isSuccess: false,
  isLoading: false,
  devices: [],
  settings: {
    headerPosition: "top",
    matrixInverted: false,
    breakPomodoroDuration: 5,
    workPomodoroDuration: 25,
  },
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setAppLevel: (state, action: PayloadAction<number>) => {
      state.appLevel = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get Settings
      .addCase(getMySettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.settings = { ...state.settings, ...action.payload };
      })
      .addCase(getMySettings.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload as string;
      })
      .addCase(getMySettings.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      // Get sessions
      .addCase(getDevices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        // Replaced, loading again (app start + settings page) must not list
        // every device twice
        state.devices = action.payload;
      })
      .addCase(getDevices.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload as string;
      })
      .addCase(getDevices.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      //
      .addCase(updateMySettings.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload as string;
      })
      .addCase(updateMySettings.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(updateMySettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.settings = { ...state.settings, ...action.payload };
      })
      // Push
      .addCase(connectWebPush.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload as string;
      })
      .addCase(connectWebPush.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(connectWebPush.fulfilled, (state, action) => {
        console.log(action.payload);
        const devices = state.devices.find((dev) => dev.active);
        if (devices) devices.hasPushSubscription = true;
      });
  },
});

// Export the synchronous action for updating role selection state.
export const { setAppLevel } = settingsSlice.actions;

// Export the reducer to be used in the store configuration.
export default settingsSlice.reducer;
